module.exports = __webpack_public_path__ + "media/images/icons/outlined/key-15a7f81a011273dcb3ea71708bde6d51.svg";